<template>
    <div class="c-modal-wrapper c-has-dark-blue-header">
      <!-- Overlay loader -->
      <overlay-loader v-if="isLoading.length > 0"></overlay-loader>        
      <!-- Application Header -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <div class="c-grid-row">
              <div class="c-col-6 c-align-right">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Otkaži</b></button>                
              </div>
              <div class="c-col-6 c-align-left">
                <button class="c-btn" v-on:click="saveChanges()"><i aria-hidden="true" class="fa fa-check c-ux-color-success"></i> <b>Sačuvaj</b></button>                
              </div>
            </div>
          </div>
        </div>
      </header>
      <!-- Body content -->
      <div class="c-modal-body c-has-skewed-background c-to-full-bottom">
        <div class="c-responsive-container">
          <form class="c-p-10" v-on:submit.prevent>
            <div class="c-info-title-labels-wrap">
              <button class="c-info-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
              <div class="c-info-title"><b>Pregled jedne rezervacije</b></div>
            </div>              
            <!-- Name, Last name -->
            <div class="c-grid-row">
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="guest-first-name">Ime gosta</label>
                  <input type="text" class="c-form-control" id="guest-first-name" name="guest-first-name"
                  v-model="formVars.guestFirstName.model">
                </div>
              </div>
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="guest-last-name">Prezime gosta</label>
                  <input type="text" class="c-form-control" id="guest-last-name" name="guest-last-name"
                  v-model="formVars.guestLastName.model">
                </div>
              </div>
            </div>          
            <!-- Nickname, Phone -->
            <div class="c-grid-row">
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="guest-nickname">Nadimak</label>
                  <input type="text" class="c-form-control" id="guest-nickname" name="guest-nickname"
                  v-model="formVars.guestNickname.model">
                </div>
              </div>
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="guest-phone-number">Telefon</label>
                  <input type="text" class="c-form-control" id="guest-phone-number" name="guest-phone-number"
                  v-model="formVars.guestPhone.model">
                </div>
              </div>
            </div>
            <!-- Guest social link -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="guest-social-link">Link ka društvenim mrežama</label>
                <div class="c-input-group">
                  <input type="text" class="c-form-control" id="guest-social-link" name="guest-social-link"
                  v-model="formVars.guestSocialLink.model">
                  <div class="c-input-addon-wrap">
                    <button class="c-addon-item"><i class="fa fa-arrow-circle-right" aria-hidden="true"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Form divider -->
            <div class="c-form-divider">Dodatne opcije</div>            
            <!-- Regular Guest List -->
            <div class="c-grid-row" v-if="formVars.listOfAllRegularGuests && formVars.listOfAllRegularGuests != 'empty'">
              <div class="c-form-group c-blue-style">
                <label for="regular-guests-list">Popuni podatke sa gostom iz baze stalnih gostiju</label>
                <select class="c-form-control" id="regular-guests-list" name="regular-guests-list" v-model="formVars.selectedRegularGuestUid.model">
                  <option v-bind:value="null">Nije stalan gost</option>
                  <option
                    v-for="(singleGuest, key) in formVars.listOfAllRegularGuests"
                    v-bind:value="singleGuest.uid"
                  ><span v-if="singleGuest.lastName">{{singleGuest.lastName}}</span> <span v-if="singleGuest.firstName">{{singleGuest.firstName}}</span> <span v-if="singleGuest.nickname">{{singleGuest.nickname}}</span></option>
                </select>
              </div>
            </div>
            <!-- Reservation status -->
            <!-- <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="guest-reservation-status">Čekiraj rezervaciju (potvrdi da je gost došao)</label>
                <div class="c-btn-group c-col-12">
                  <button class="c-btn c-passive-blue-btn c-col-4"><b>Čeka se</b></button>
                  <button class="c-btn c-passive-blue-btn c-col-4"><b>Došao</b></button>
                  <button class="c-btn c-passive-blue-btn c-col-4"><b>Nije došao</b></button>
                </div>                
              </div>
            </div> -->
            <!-- Switch reservations -->
            <!-- <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="guest-reservation-switch">Zameni ovu rezervaciju sa drugim stolom</label>
                <select class="c-form-control" id="guest-reservation-switch" name="guest-reservation-switch">
                  <option disabled value="null">Please select...</option>
                  <option v-for="(itemOption, index) in 3" :value="index">Select option {{index}}</option>
              </select>                
              </div>
            </div> -->
            <!-- Cancel Reservation / Clear fields  -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="drinks-revenue">Obriši sva polja</label>
                <button class="c-btn c-passive-blue-btn c-col-12" v-on:click="clearFormData()"><i class="fa fa-ban" aria-hidden="true"></i> <b>Obriši sva polja</b></button>
              </div>
            </div>
            <!-- Form divider -->
            <div class="c-form-divider">Informacije o potrošnji gosta</div>
            <!-- Table Bill -->
            <div class="c-grid-row">
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="guest-table-bill">Račun stola</label>
                  <div class="c-input-group">
                    <input v-model="formVars.tableBill.model" type="text" class="c-form-control" id="guest-table-bill" name="guest-table-bill">
                    <div class="c-input-addon-wrap">
                      <button class="c-addon-item">RSD</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="guest-table-waiter">Konobar koji je sluzio ovaj sto</label>
                  <select class="c-form-control" id="guest-table-waiter" name="guest-table-waiter" v-model="formVars.tableWaiterUid.model">
                    <option v-bind:value="null">Izaberi..</option>
                    <option 
                    v-for="(singleWaiter, key) in formVars.listOfAllWaiters"
                    v-bind:value="singleWaiter.uid"
                    >
                      <span v-if="singleWaiter.lastName">{{singleWaiter.lastName}}</span> <span v-if="singleWaiter.firstName">{{singleWaiter.firstName}}</span> <span v-if="singleWaiter.nickname">{{singleWaiter.nickname}}</span>
                    </option>
                </select>

                <!-- <select class="c-form-control" id="regular-guests-list" name="regular-guests-list" v-model="formVars.selectedRegularGuestUid.model">
                  <option v-bind:value="null">Nije stalan gost</option>
                  <option
                    v-for="(singleGuest, key) in formVars.listOfAllRegularGuests"
                    v-bind:value="singleGuest.uid"
                  ><span v-if="singleGuest.lastName">{{singleGuest.lastName}}</span> <span v-if="singleGuest.firstName">{{singleGuest.firstName}}</span> <span v-if="singleGuest.nickname">{{singleGuest.nickname}}</span></option>
                </select>                 -->
                </div>
              </div>
            </div>
            <!-- Table order list -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="guest-table-orders">Lista narucivanog pica</label>
                <textarea v-model="formVars.tableOrderedDrinks.model" class="c-form-control" id="guest-table-orders" name="guest-table-orders"></textarea>
              </div>
            </div>
            <!-- Complimentary drinks list -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="guest-table-complimentary">Lista gratisa</label>
                <textarea v-model="formVars.tableComplimentaryDrinks.model" class="c-form-control" id="guest-table-complimentary" name="guest-table-complimentary"></textarea>
              </div>
            </div>              
          </form>
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <!-- <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          <div class="c-grid-row c-footer-action-buttons-wrap">
            <div class="c-col-6 c-align-right">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-success" v-on:click="saveChanges()"><i class="fa fa-check" aria-hidden="true"></i> <b>Sačuvaj</b></button>
            </div>
            <div class="c-col-6 c-align-left">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-danger" v-on:click="cancelChanges()"><i class="fa fa-times" aria-hidden="true"></i> <b>Otkaži</b></button>
            </div>
          </div>
        </div>
      </footer> -->
    </div>
</template>

<script>
import router from '@/router/index'
import EventBus from '@/EventBus'
import {firebaseDB} from '@/firebase';
import OverlayLoader from "@/components/helpers/OverlayLoader";
export default {
  name: 'ModalSingleArchivedReservation',
  props: ['inputModalData'],
  components: {
    OverlayLoader: OverlayLoader
  },      
  // firebase: function () {
  //   return {
  //     listOfRegularGuests: {
  //       source: firebaseDB.ref('listOfRegularGuests'),
  //       // optionally provide the cancelCallback, if the app client doesn't have permission to read from that database reference
  //       //cancelCallback: function (error) {console.log('!!! - IMPORTANT - cancelCallback');},
  //       // this is called once the data has been retrieved from firebase
  //       readyCallback: function (dataSnapshot) {
  //         this.isLoading.pop();
  //         this.formVars.listOfAllRegularGuests = dataSnapshot.val();
  //         console.log('listOfAllRegularGuests READY: ');
  //         //console.log('listOfAllRegularGuests to: ' + JSON.stringify(dataSnapshot.val(), null, 2));
  //       }
  //     }      
  //   }
  // },   
  data () {
    return {
      msg: 'ModalSingleArchivedReservation modal',
      // !!! VERY IMPORTANT ---
      // this 

      visibleForAllisOn: false,
      selectedEventReservationsKey: null,
      selectedEventUidKey: null,
      selectedTableObject: null,
      //when we load this screen if table/reservation had guest information, then we want to rebind that to view
      // one more purpose of this variable is to prevent twice update of guest information (1. we manually update data if guest info received, 2. after we changed 'selectedRegularGuestUid', it will trigger binding one more time)
      // this variable will prevent double init of binding
      isFirstBindFinished: false,
      isLoading: [1],
      formVars: {
        isValid: false,
        listOfAllRegularGuests: null,
        listOfAllWaiters: null,
        guestFirstName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        guestLastName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        guestNickname: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        guestPhone: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        guestSocialLink: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        selectedRegularGuestUid: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        tableBill: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        tableWaiterUid: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        tableOrderedDrinks: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },        
        tableComplimentaryDrinks: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        }                
      },
      resolve: null,
      reject: null
    }
  },
  watch: {
    'formVars.selectedRegularGuestUid.model' : function (newUidValue){
      //console.log('formVars.selectedRegularGuestUid.model changed to: ' + JSON.stringify(newUidValue, null, 2));
      //console.log('regular-guest-key: ' + newUidValue);
      //this.rebindDataWhenRegularGuestModelChanged(newUidValue);      
      this.rebindDataWhenRegularGuestModelChanged(newUidValue);
    }
  },  
  methods: {
    // ~ When we want to save changes created on this modal
    saveChanges: function (){
      var isFormValid = this.returnNewEventFormState();
      if (isFormValid){
        this.isLoading.push(1);
        firebaseDB.ref().child('/listOfAllEventsReservations/' + this.selectedEventReservationsKey + '/' + this.selectedTableObject.uid).update({
          guestFirstName: (this.formVars.guestFirstName.model) ? this.formVars.guestFirstName.model : null,
          guestLastName: (this.formVars.guestLastName.model) ? this.formVars.guestLastName.model : null,
          guestNickname: (this.formVars.guestNickname.model) ? this.formVars.guestNickname.model : null,
          guestPhone: (this.formVars.guestPhone.model) ? this.formVars.guestPhone.model : null,
          guestSocialLink: (this.formVars.guestSocialLink.model) ? this.formVars.guestSocialLink.model : null,
          regularGuestKey: (this.formVars.selectedRegularGuestUid.model) ? this.formVars.selectedRegularGuestUid.model : null,
            // tableViewUid: (this.selectedTableObject && this.selectedTableObject['.key']) ? this.selectedTableObject['.key'] : null,
            // tableViewName: (this.selectedTableObject && this.selectedTableObject.tableShortName && this.selectedTableObject.tableNumber) ? (this.selectedTableObject.tableShortName + this.selectedTableObject.tableNumber) : null,
          tableBill: (this.formVars.tableBill.model) ? this.formVars.tableBill.model : null,
          tableWaiterUid: (this.formVars.tableWaiterUid.model) ? this.formVars.tableWaiterUid.model : null,
          tableOrderedDrinks: (this.formVars.tableOrderedDrinks.model) ? this.formVars.tableOrderedDrinks.model : null,
          tableComplimentaryDrinks: (this.formVars.tableComplimentaryDrinks.model) ? this.formVars.tableComplimentaryDrinks.model : null          
        }).then(
          function (response) {
            //console.log('Firebase Single Reservation Update succ: ' + JSON.stringify(response, null, 2));
            /* 
              !!! VERY IMPORTANT - We must check if admin deleted speding info for some Regular Guest
              Scenario:
              1. This table had Regular Guest that reserved this table and/or some spendind histtory (drinks sold, complimentary..)
              2. Admin cleared info about that Regular Guest, meaning that he want to delete everything related to this Regular guest
              3. Since Admin cleard info, we must also delete info about this table inside Regular Guest spending history
              4. Why.. If spending info for this tabel is deleted, then Regular Guest don't need to have this table in his spending history
            */
            if (this.selectedTableObject && this.selectedTableObject.regularGuestKey && (this.selectedTableObject.regularGuestKey != this.formVars.selectedRegularGuestUid.model) ){
              //console.log('ABOUT THAT THING::: CHANGED');
              // !!! IF Admin changed regular guest, then we must take some actions
              firebaseDB.ref().child("listOfRegularGuestsHistory/" + this.selectedTableObject.regularGuestKey + '/' + this.selectedEventUidKey).remove().then(
                function(response) {
                  var resultToReturn = {
                    tempMsg: 'ModalSingleArchivedReservation returns Yes without error AFTER removing regular guest history'
                  }
                  this.resolve(resultToReturn);
                }.bind(this),
                function(error) {
                  console.log('ModalSingleArchivedReservation -remove-regular-guest-history ERROR: ' + JSON.stringify(error, null, 2));
                }.bind(this)
              );
              //// if user selected new Regular Guest, then we must save data for that Regular guest history
            }else{
              //console.log('ABOUT THAT THING::: SAME');
              var resultToReturn = {
                tempMsg: 'ModalSingleArchivedReservation returns Yes'
              }
              this.resolve(resultToReturn);              
            }
          }.bind(this),
          function (error){
            console.log('Firebase Single Reservation Update ERROR: ' + JSON.stringify(error, null, 2));
          }.bind(this)
        );
      } 
    },
    returnNewEventFormState: function () {
      var returnValue = true;
      //
      return returnValue;
    },
    /////
    bindExistingDataToForm: function (inputReservationObject) {      
      //console.log('bindExistingDataToForm start');
      //bind received info about guest details (name, last name..)
      this.formVars.guestFirstName.model = (inputReservationObject && inputReservationObject.guestFirstName) ? inputReservationObject.guestFirstName : null;
      this.formVars.guestLastName.model = (inputReservationObject && inputReservationObject.guestLastName) ? inputReservationObject.guestLastName : null;
      this.formVars.guestNickname.model = (inputReservationObject && inputReservationObject.guestNickname) ? inputReservationObject.guestNickname : null;
      this.formVars.guestPhone.model = (inputReservationObject && inputReservationObject.guestPhone) ? inputReservationObject.guestPhone : null;
      this.formVars.guestSocialLink.model = (inputReservationObject && inputReservationObject.guestSocialLink) ? inputReservationObject.guestSocialLink : null;      
      // bind received info about table bill info
      this.formVars.tableBill.model = (inputReservationObject && inputReservationObject.tableBill) ? inputReservationObject.tableBill : null;
      this.formVars.tableWaiterUid.model = (inputReservationObject && inputReservationObject.tableWaiterUid) ? inputReservationObject.tableWaiterUid : null;
      this.formVars.tableOrderedDrinks.model = (inputReservationObject && inputReservationObject.tableOrderedDrinks) ? inputReservationObject.tableOrderedDrinks : null;
      this.formVars.tableComplimentaryDrinks.model = (inputReservationObject && inputReservationObject.tableComplimentaryDrinks) ? inputReservationObject.tableComplimentaryDrinks : null;      
      //console.log('bindExistingDataToForm END');
    },    
    rebindDataWhenRegularGuestModelChanged: function (inputRegularGuestUid) {
      var tmpSelectedGuestObj = null;
      //console.log('rebindDataWhenRegularGuestModelChanged start');
      if (this.formVars.listOfAllRegularGuests && inputRegularGuestUid){
        // when 'selectedRegularGuestUid' model is changed then we must check if user selected regular guest or deselected any of the regular guest
        for (var key  in this.formVars.listOfAllRegularGuests) {
          if (this.formVars.listOfAllRegularGuests.hasOwnProperty(key) && key === inputRegularGuestUid) {
            tmpSelectedGuestObj = this.formVars.listOfAllRegularGuests[key];
            //console.log('found selected guest by id: ' + key + ', object is: ' +  JSON.stringify(this.formVars.listOfAllRegularGuests[key], null, 2));
            // ~ since user selected different regular guest from list of guests, that means that we need to bind info about that newly selected regular guest
            this.formVars.guestFirstName.model = (tmpSelectedGuestObj && tmpSelectedGuestObj.firstName) ? tmpSelectedGuestObj.firstName : null;
            this.formVars.guestLastName.model = (tmpSelectedGuestObj && tmpSelectedGuestObj.lastName) ? tmpSelectedGuestObj.lastName : null;
            this.formVars.guestNickname.model = (tmpSelectedGuestObj && tmpSelectedGuestObj.nickname) ? tmpSelectedGuestObj.nickname : null;
            this.formVars.guestPhone.model = (tmpSelectedGuestObj && tmpSelectedGuestObj.phone) ? tmpSelectedGuestObj.phone : null;
            this.formVars.guestSocialLink.model = (tmpSelectedGuestObj && tmpSelectedGuestObj.socialLink) ? tmpSelectedGuestObj.socialLink : null;
            // since 'rebindDataWhenRegularGuestModelChanged' is triggered when user selected different regular guest, that means that we need to clear all info about spending from that previous guest
            this.formVars.tableBill.model = null;
            this.formVars.tableWaiterUid.model = null;
            this.formVars.tableOrderedDrinks.model = null;
            this.formVars.tableComplimentaryDrinks.model = null;
            break;
          }
        }
        ///
        if (tmpSelectedGuestObj && tmpSelectedGuestObj.regularGuestKey){
          //console.log('tmpSelectedGuestObj.regularGuestKey afirmative');
          this.bindExistingDataToForm(tmpSelectedGuestObj);
        }
      }else{
        // else if user deselected any regular guest, then must clear values from forms
        this.clearFormData();
      }
      //console.log('rebindDataWhenRegularGuestModelChanged END');
    },
    clearFormData: function () {
      //console.log('clearFormData start');
      this.formVars.guestFirstName.model = null;
      this.formVars.guestLastName.model = null;
      this.formVars.guestNickname.model = null;
      this.formVars.guestPhone.model = null;
      this.formVars.guestSocialLink.model = null;      
      this.formVars.tableBill.model = null;
      this.formVars.tableWaiterUid.model = null;
      this.formVars.tableOrderedDrinks.model = null;
      this.formVars.tableComplimentaryDrinks.model = null;
      // prevent loping 'clearFormData' each time we deselect regular guest
      if (this.formVars.selectedRegularGuestUid.model){
        this.formVars.selectedRegularGuestUid.model = null;
      }
      //console.log('clearFormData end');
    },    
    ///
    // ~ When we want to discard changes
    cancelChanges: function (){
      this.reject();
    }
  },
  created () {
    //console.log('~ created- ModalSingleArchivedReservation component!');
    if (this.inputModalData){
      //console.log('inputModalData SingleArhciveRes: ' + JSON.stringify(this.inputModalData, null, 2) );
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.eventReservationsKey){
        this.selectedEventReservationsKey = this.inputModalData.dataForModal.eventReservationsKey;
      }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.eventUidKey){
        this.selectedEventUidKey = this.inputModalData.dataForModal.eventUidKey;
      }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.listOfAllRegularGuests){
        this.formVars.listOfAllRegularGuests = this.inputModalData.dataForModal.listOfAllRegularGuests;
      }
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.listOfAllWaiters){
        this.formVars.listOfAllWaiters = this.inputModalData.dataForModal.listOfAllWaiters;
      }      
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
      this.isLoading.pop();
    }
  // "dataForModal": {
  //   "selectedReservationItem": {
  //     "guestFirstName": "Viki",
  //     "guestLastName": "Vikic",
  //     "guestNickname": "Vuka",
  //     "guestPhone": "0692598187",
  //     "tableBill": "33333",
  //     "tableCheckedInStatus": 1,
  //     "tableComplimentaryDrinks": "1 x smirnoff",
  //     "tableLocked": {
  //       "status": false
  //     },
  //     "tableNumber": 3,
  //     "tableOrderedDrinks": "10 x smirfnott",
  //     "tableShortName": "B",
  //     "uid": "-L6gvfOBnH-pEtb7RZZK_B_003"
  //   },
  //   "eventReservationsKey": "-L8S0PawhrZY5wOE55JX"
  // }    
  },
  mounted () {
    //console.log('~ mounted - ModalSingleArchivedReservation component!');
    if (this.inputModalData){
      //console.log('inputModalData SingleArhciveRes: ' + JSON.stringify(this.inputModalData, null, 2) );
      if (this.inputModalData.dataForModal && this.inputModalData.dataForModal.selectedReservationItem){
        this.selectedTableObject = this.inputModalData.dataForModal.selectedReservationItem;        
        //this.formVars.selectedRegularGuestUid.model = (this.selectedTableObject && this.selectedTableObject.regularGuestKey) ? this.selectedTableObject.regularGuestKey : null;
        this.bindExistingDataToForm(this.selectedTableObject);
        if (this.selectedTableObject.regularGuestKey){
          // if we received info with REGULAR GUEST, then we need to store UID of that regular guest
          //console.log('bindExistingDataToForm fired: regularGuestKey: ' + inputReservationObject.regularGuestKey);
          this.formVars.selectedRegularGuestUid.model = (this.selectedTableObject && this.selectedTableObject.regularGuestKey) ? this.selectedTableObject.regularGuestKey : null;         
        }        
        //console.log('this.selectedTableObject: ' +  JSON.stringify(this.selectedTableObject, null, 2));        
      }
    }    
  },
  destroyed () {
    //console.log('~ destroyed- ModalSingleArchivedReservation component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/eventsArchive/ModalSingleArchivedReservation.vue